import Api from "../services/AxiosService";
import { unwrap } from "./envelope";

export interface ProfilFastener {
  partNo: string;
  type: string | null;
  rivetingForceKn: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface PaginationMeta {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface PaginatedProfilFasteners {
  data: ProfilFastener[];
  pagination: PaginationMeta;
}

export interface ListProfilFastenersParams {
  page?: number;
  limit?: number;
  search?: string;
}

export interface CreateProfilFastenerBody {
  partNo: string;
  type?: string | null;
  rivetingForceKn?: string | number | null;
}

export interface UpdateProfilFastenerBody {
  type?: string | null;
  rivetingForceKn?: string | number | null;
}

export async function listProfilFasteners(
  params: ListProfilFastenersParams = {},
): Promise<PaginatedProfilFasteners> {
  const res = await Api.get("/v1/profil-fasteners", { params });
  return unwrap<PaginatedProfilFasteners>(res.data);
}

export async function getProfilFastener(partNo: string): Promise<ProfilFastener> {
  const res = await Api.get(`/v1/profil-fasteners/${encodeURIComponent(partNo)}`);
  return unwrap<ProfilFastener>(res.data);
}

export async function createProfilFastener(
  body: CreateProfilFastenerBody,
): Promise<ProfilFastener> {
  const res = await Api.post("/v1/profil-fasteners", body);
  return unwrap<ProfilFastener>(res.data);
}

export async function updateProfilFastener(
  partNo: string,
  body: UpdateProfilFastenerBody,
): Promise<ProfilFastener> {
  const res = await Api.put(`/v1/profil-fasteners/${encodeURIComponent(partNo)}`, body);
  return unwrap<ProfilFastener>(res.data);
}

export async function deleteProfilFastener(partNo: string): Promise<{ success: true }> {
  const res = await Api.delete(`/v1/profil-fasteners/${encodeURIComponent(partNo)}`);
  return unwrap<{ success: true }>(res.data);
}
